<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">停车场管理</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="名称" prop="CarParkName">
            <el-input v-model="CarParkName" placeholder="请输入名称"></el-input>
          </el-form-item>
          <!-- <el-form-item label="类型">
            <el-select v-model="Description" placeholder="请选择">
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in typeArr"
                :key="item.ItemKey"
                :label="item.Description"
                :value="item.ItemValue"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column prop="name" label="停车场名称"></el-table-column>

              <el-table-column
                prop="totalNum"
                label="总停车位"
              ></el-table-column>
              <el-table-column
                prop="surplusNum"
                label="剩余车位"
              ></el-table-column>
              <el-table-column prop="Longitude" label="经度"></el-table-column>
              <el-table-column prop="Latitude" label="纬度"></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import { getList, deleteByIds } from "@/api/src/entityBaseAllInfo";
export default {
  name: "ScenicCarParkManagerView",
  controller: "UI",
  action: "ScenicCarParkManagerView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      typeArr: [],
      CarParkName: "",
      Description: "",
    };
  },
  mounted: function () {
    this.search();

    this.logInfo.ActionName = "停车场列表查询";
    this.logInfo.LogMessage = "停车场列表查询";
    this.logInfo.ModuleName = "停车场系统";
    this.logInfo.PageName = "停车场列表";
    // this.addOperationLog();
  },
  methods: {
    search() {
      let searchInfo = {
        belongUnitCode: "",
        code: "",
        columnName: "id",
        columnSortType: "desc",
        entityTypeCode: "",
        name: this.CarParkName,
        size: this.pageSize,
        page: this.currentPage,
        type: "resource",
        typeOneCode: "parking",
        typeTwoCode: "",
      };
      getList(searchInfo).then((response) => {
        this.tableData = response.data;
        this.tableData.map((item) => {
          if (item.poi) {
            const pois = item.poi.split(",");
            if (pois.length > 1) {
              item.Longitude = pois[0];
              item.Latitude = pois[1];
            }
          }
        });
        this.total = response.count;
        this.loading = false;
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/carpark/UI/ScenicCarParkManagerEdit",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/carpark/ui/ScenicCarParkManagerEdit",
        query: { InfoId: row.code, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/carpark/ui/ScenicCarParkManagerEdit",
        query: { InfoId: row.code, type: "edit" },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteByIds({ ids: row.code, type: "parking" }).then((response) => {
            if (response.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.search();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      if (new Date(this.EndTime) < new Date(this.BeginTime)) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.CarParkName = "";
      this.Description = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    EquTypeToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const Description = this.typeArr
        .map((item) => {
          if (item.ItemValue == data) return item.Description;
        })
        .join("");
      if (Description == null || Description == "") {
        return data;
      }
      return Description;
    },
  },
};
</script>
